export enum TRADE_STEPS {
  CHOOSE_ASSETS = 'TRADE_CHOOSE_ASSETS',
  FORM = 'TRADE_FORM',
  COMPLETED_STATUS = 'TRADE_COMPLETED_STATUS',
  SUMMARY = 'TRADE_SUMMARY',
}
